/* src/app/location-users/add-location-users/new-user-queue/new-user-queue-location/queue-user/queue-user.component.scss */
.user-queue-display,
.button-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-weight: 600;
  padding: 20px;
  padding-top: 10px;
}
.user-queue-display label,
.button-section label {
  display: block;
}
.user-queue-display label:has(~ .error-message),
.button-section label:has(~ .error-message) {
  color: #C91913;
}
.user-queue-display .user-queue-ups-id,
.button-section .user-queue-ups-id {
  width: 15%;
}
.user-queue-display .large-column,
.button-section .large-column {
  position: relative;
  width: 35%;
  display: flex;
  flex-direction: column;
}
.user-queue-display .large-column .error,
.button-section .large-column .error {
  border: 2px solid #C91913;
  padding: 5px;
}
.user-queue-display .large-column .user-queue-email,
.button-section .large-column .user-queue-email {
  text-overflow: ellipsis;
  overflow: hidden;
  display: inherit;
}
.user-queue-display .role,
.button-section .role {
  width: 25%;
}
.user-queue-display .role .error,
.button-section .role .error {
  border: 2px solid #C91913;
  min-height: 35px;
}
.user-queue-display select,
.button-section select {
  padding: 6px 12px;
  height: 38px;
  border: solid 1px #979797;
}
.button-section .cancel-link {
  display: block;
  float: left;
  margin-right: 30px;
  margin-top: 7px;
  text-decoration: underline;
}
.user-queue-display .user-queue-icons {
  display: flex;
  justify-content: right;
}
.error-message {
  color: #C91913;
  font-weight: 500;
  font-size: 16px;
}
.error-message::before {
  font-family: "upsicons", fantasy !important;
  content: "\e638" !important;
}
.ups-icon-x,
.ups-icon-edit {
  cursor: pointer;
  color: #426DA9;
}
button {
  height: 36px;
  min-width: 190px;
  background-color: #00857D;
  border-radius: 100px;
  color: white;
  border: 0;
  white-space: nowrap;
}
.btn-white {
  color: #00857D;
  background-color: white;
  border-radius: 35px;
  border: thin #00857D solid;
  width: 97px;
  height: 36px;
}
.ups-icon-edit {
  margin-right: 10px;
}
.ups-icon-edit::before {
  font-family: "upsicons", fantasy !important;
  content: "\e636" !important;
}
.readonly-ups-id {
  line-height: 38px;
}
/*# sourceMappingURL=queue-user.component.css.map */
